export default __webpack_public_path__ + "static/media/Icon-Newfeed.61248e33.svg";